import {
  EChatActionTypes,
  TDisableSendDefaultMessagePayload,
  TEditableMessagePayload,
  TBubbleInputFocusPayload,
} from './types';
import { TMessageSchema } from '../../types/messages';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const addIncomingMessage = actionGenerator<EChatActionTypes.IncomingMessage, TMessageSchema>(
  EChatActionTypes.IncomingMessage,
);

export const setEditableMessage = actionGenerator<EChatActionTypes.SetEditableMessage, TEditableMessagePayload>(
  EChatActionTypes.SetEditableMessage,
);
export const disableSendDefaultMessage = actionGenerator<
  EChatActionTypes.DisableSendDefaultMessage,
  TDisableSendDefaultMessagePayload
>(EChatActionTypes.DisableSendDefaultMessage);

export const closeChat = actionGenerator<EChatActionTypes.Close>(EChatActionTypes.Close);

export const resetChat = actionGenerator<EChatActionTypes.Reset>(EChatActionTypes.Reset);

export const setBubbleInputFocus = actionGenerator<EChatActionTypes.SetBubbleInputFocus, TBubbleInputFocusPayload>(
  EChatActionTypes.SetBubbleInputFocus,
);
